<app-demo-external
    [iframeUrl]="iframeUrl()"
    [platformValidate]="onPlatformValidate.bind(this)"
    (activityDone)="onActivityDone()"
></app-demo-external>
